import { Button, Modal } from 'antd'
import React, { useCallback, useState } from 'react'

import { Media } from '@/model/media'

import MediaColumn from './media-column'
import s from './vault-modal.module.css'

export interface VaultModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  onAddMedias: (medias: Media[]) => void
  platformUserId: number
  excludedMediaUrls: string[]
  maxSelection?: number
  creatorId: number
}

export function VaultModal({
  creatorId,
  open,
  setOpen,
  onAddMedias,
  excludedMediaUrls,
  maxSelection,
}: VaultModalProps) {
  const [selectedMedias, setSelectedMedias] = useState<Media[]>([])
  const onAdd = useCallback(() => {
    setOpen(false)
    onAddMedias(selectedMedias)
    setSelectedMedias([])
  }, [onAddMedias, selectedMedias, setOpen])

  return (
    <Modal
      classNames={{ body: s.ModalBody }}
      key={creatorId}
      open={open}
      onCancel={() => setOpen(false)}
      footer={<Button onClick={() => setOpen(false)}>Close</Button>}
      title={null}
      closeIcon={null}
      width={900}
      destroyOnClose
      centered
    >
      <MediaColumn
        className={s.MediaColumn}
        creatorId={creatorId}
        maxSelection={maxSelection}
        onAdd={onAdd}
        selectedMedias={selectedMedias}
        onSelectMedias={setSelectedMedias}
        excludedMediaUrls={excludedMediaUrls}
        enableSelection
      />
    </Modal>
  )
}
